import { Option } from 'funfix-core';
import React from 'react';
import { ANALYTICS_MODAL_CREATE_TOKEN } from '../../../../../analytics/Sources';
import DialogCustomContainer from '../../common/DialogCustomContainer';
import DialogCreateAppSpecificPasswordContent from './DialogCreateAppSpecificPasswordContent';
import DialogCreateAppSpecificPasswordFooter from './DialogCreateAppSpecificPasswordFooter';
const resolveDialogCreateAppSpecificPassword = _ref => {
  var _appSpecificPasswordI;
  let {
    appSpecificPasswordInstallMode,
    closeInstallDialog,
    context,
    generateAppSpecificPassword,
    hostConfig,
    openManualUrlInstallDialog,
    openAppSpecificPasswordDialog,
    setAppSpecificPasswordName
  } = _ref;
  return {
    analyticsSourceModal: ANALYTICS_MODAL_CREATE_TOKEN,
    content: /*#__PURE__*/React.createElement(DialogCustomContainer, {
      installMode: appSpecificPasswordInstallMode,
      openManualUrlInstallDialog: openManualUrlInstallDialog,
      openAppSpecificPasswordDialog: openAppSpecificPasswordDialog
    }, /*#__PURE__*/React.createElement(DialogCreateAppSpecificPasswordContent, {
      appSpecificPasswordInstallMode: appSpecificPasswordInstallMode,
      hostConfig: hostConfig,
      setAppSpecificPasswordName: setAppSpecificPasswordName
    })),
    heading: 'Custom app',
    footerRight: /*#__PURE__*/React.createElement(DialogCreateAppSpecificPasswordFooter, {
      closeInstallDialog: closeInstallDialog,
      context: context,
      generateAppSpecificPassword: generateAppSpecificPassword,
      hostConfig: hostConfig,
      name: (_appSpecificPasswordI = appSpecificPasswordInstallMode.appSpecificPassword) === null || _appSpecificPasswordI === void 0 ? void 0 : _appSpecificPasswordI.name
    }),
    preventDialogClosing: false,
    errorDetails: Option.empty()
  };
};
export default resolveDialogCreateAppSpecificPassword;